export const GET_ALL_REPORTS_PROFILE = "GET_ALL_REPORTS_PROFILE";
export const START_LOADING_REPORTS_PROFILE = "START_LOADING_REPORTS_PROFILE";
export const ERROR_LOADING_REPORTS_PROFILE = "ERROR_LOADING_REPORTS_PROFILE";
export const STOP_LOADING_REPORTS_PROFILE = "STOP_LOADING_REPORTS_PROFILE";
export const REPORTS_VERSIONS = "REPORTS_VERSIONS";
export const RESET_DATA = "RESET_DATA";
